import React from 'react';
import { EdgeProps, EdgeTypes, getBezierPath, getSmoothStepPath, getStraightPath } from 'reactflow';

function CustomEdge({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    data,
    markerEnd,
    label
}: any) {

    const [edgePath] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        offset: 50,
        // centerX: sourceX - targetX,
        // centerY: sourceY - targetY,
    })

    return (
        <>
            <path
                id={id}
                style={style}
                className="react-flow__edge-path"
                d={edgePath}
                // markerEnd={markerEnd}
            />
            <text>
                <textPath href={`#${id}`} style={{ fontSize: 12 }} startOffset="50%" textAnchor="middle">
                    {label}
                </textPath>
            </text>
        </>
    );
}
export default CustomEdge